var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    enableBackground: "new 0 0 50 50",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E51A32",
    d: "M24.999,2.837c-12.25,0-22.215,9.966-22.215,22.216c0,12.251,9.965,22.219,22.215,22.219 s22.217-9.968,22.217-22.219C47.216,12.803,37.249,2.837,24.999,2.837z M33.892,33.865c-0.523,0.54-1.406,0.581-1.98,0.091 c-0.082-0.07-0.158-0.152-0.237-0.229c-2.132-2.134-4.268-4.268-6.399-6.403c-0.084-0.084-0.142-0.195-0.277-0.389 c-0.129,0.188-0.183,0.304-0.268,0.389c-2.146,2.152-4.299,4.299-6.444,6.453c-0.434,0.434-0.932,0.626-1.53,0.472 c-0.978-0.253-1.357-1.467-0.713-2.257c0.084-0.103,0.18-0.194,0.274-0.287c2.118-2.119,4.234-4.238,6.356-6.354 c0.094-0.092,0.223-0.147,0.336-0.219c0.004-0.061,0.012-0.12,0.016-0.181c-0.115-0.067-0.252-0.114-0.344-0.205 c-2.122-2.114-4.24-4.233-6.359-6.353c-0.092-0.094-0.188-0.186-0.271-0.287c-0.453-0.549-0.426-1.366,0.058-1.876 c0.489-0.518,1.325-0.586,1.894-0.147c0.123,0.094,0.23,0.206,0.34,0.314c2.118,2.118,4.238,4.236,6.355,6.355 c0.084,0.086,0.156,0.185,0.379,0.355c0.054-0.111,0.088-0.243,0.169-0.326c2.155-2.162,4.313-4.316,6.468-6.479 c0.338-0.339,0.721-0.542,1.204-0.506c0.577,0.043,1.007,0.328,1.218,0.873c0.217,0.563,0.122,1.092-0.303,1.528 c-0.662,0.679-1.337,1.342-2.008,2.012c-1.518,1.52-3.037,3.038-4.555,4.558c-0.084,0.084-0.165,0.172-0.34,0.355 c0.133,0.08,0.267,0.13,0.359,0.223c2.111,2.092,4.221,4.189,6.33,6.286c0.092,0.095,0.189,0.185,0.277,0.282 C34.407,32.476,34.403,33.337,33.892,33.865z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/Close.93ab92c7f72dcfe926ce456b45e90265.svg";
export { ForwardRef as ReactComponent };